import { useState } from 'react'

import { MutationInputError } from 'providers/tanstack-query/types'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPLOAD_AD_UNITS_CONFIGURATION } from './api/mutation'
import { Data, Variables } from './api/types'
import {
  UploadStatus,
  UseUploadAdUnitsConfiguration,
  UseUploadAdUnitsConfigurationProps,
} from './types'

export const useUploadAdUnitsConfiguration = ({
  domainId,
}: UseUploadAdUnitsConfigurationProps): UseUploadAdUnitsConfiguration => {
  const [response, setResponse] = useState<UploadStatus>({ status: 'initial' })

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPLOAD_AD_UNITS_CONFIGURATION,
    onCompleted: async (data: Data) => {
      const { uploadAdUnitsXls } = data

      if (uploadAdUnitsXls) {
        const { errors } = uploadAdUnitsXls

        if (errors && errors.length > 0) {
          setResponse({
            errors: errors.map((e: MutationInputError): MutationInputError['message'] => e.message),
            status: 'failure',
          })
        }
      } else setResponse({ status: 'success' })
    },
  })

  const upload = (file: File) => {
    setResponse({ status: 'loading' })

    return mutateAsync({
      input: {
        id: domainId,
        xlsxFile: file,
      },
    })
  }

  return {
    reset: () => setResponse({ status: 'initial' }),
    response,
    upload,
  }
}
